import React from "react";
import IMG from "./assets/destination/NewYork.jpg"
import '../src/style/contact.css';

const About = () => {
  return (<>
    <nav
      className="breadcrumb"
      style={{
        backgroundImage: "url('./airplane.avif')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: "55px",
        color: "#152545"
      }}
    >
      <a href="/">Home</a> &gt; <span>About Us</span>
    </nav>

    <section className="container py-5 about-sec" style={{backgroundColor:"rgb(240, 243, 245);"}}>
      <div className="row align-items-center">
        <div className="col-md-6">
          <img
            src={IMG}
            alt="Flight Booking"
            className="img-fluid rounded shadow"
          />
        </div>
        <div className="col-md-6">
          <h2 className="mb-3" style={{ color: "#152545" }}>About Our Flight Booking System</h2>
          <p className="text-muted">
            We specialize in affordable and hassle-free flight bookings for travelers across the USA. Whether you're planning a business trip, a family vacation, or a last-minute getaway, our platform connects you with the best flight deals from 400+ airlines worldwide. We believe that booking a flight should be easy, convenient, and budget-friendly, which is why we offer 24/7 customer support and expert assistance at every step of your journey.

            Our team of dedicated travel specialists works tirelessly to bring you the lowest airfare options, ensuring that you get the best value for your money. From personalized flight recommendations to seamless booking and instant e-ticket delivery, we make sure your travel planning experience is smooth and stress-free. Our secure booking system and real-time updates ensure that you always stay informed about your flight details.

          </p>
        </div>
      </div>
    </section>
    <section className="container mt-3">

      <div className="row about-sec">

        {/* Our Mission */}
        <div className="col-6 text-center md:text-left p-3">
          <h2 className="text-3xl font-extrabold text-blue-700 mb-4">Our Mission</h2>
          <p className="text-gray-700 text-lg leading-relaxed">
            We strive to provide cost-effective flight booking solutions with unmatched
            customer service, making air travel affordable, convenient, and accessible for everyone.
          </p>
        </div>

        {/* Our Vision */}
        <div className="col-6 text-center md:text-left p-3">
          <h2 className="text-3xl font-extrabold text-blue-700 mb-4">Our Vision</h2>
          <p className="text-gray-700 text-lg leading-relaxed">
            Our goal is to be recognized as the most reliable and budget-friendly flight
            booking platform, helping millions of travelers find the best deals while ensuring
            a seamless and enjoyable travel experience.
          </p>
        </div>

      </div>

    </section>
  </>
  );
};

export default About;
